import { Tab, Tabs } from '@mui/material'
import { useState } from 'react'
import { tabsStyles, tabStyles } from './NavigationHeader.styles'

export interface NavigationHeaderModule {
  label: string
  action: () => void
}

interface NavigationHeaderProps {
  navigationHeaders: NavigationHeaderModule[]
}

function NavigationHeader({ navigationHeaders }: NavigationHeaderProps) {
  const [selectedTab, setSelectedTab] = useState('menu-tab-0')

  const handleChange = (_event: React.SyntheticEvent, newValue: string) => {
    setSelectedTab(newValue)
  }

  return (
    <Tabs value={selectedTab} onChange={handleChange} sx={tabsStyles}>
      {navigationHeaders.map((header, index) => (
        <Tab
          key={header.label}
          label={header.label}
          value={`menu-tab-${index}`}
          disableRipple
          sx={tabStyles}
          onClick={header.action}
        />
      ))}
    </Tabs>
  )
}

export default NavigationHeader
